import RichTooltip from 'LuxKit/RichTooltip'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const TooltipIcon = styled.span`
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${rem(16)};
  height: ${rem(16)};
  margin-inline-start: ${rem(6)};
  vertical-align: middle;
  line-height: 0;
  position: relative;
  top: ${rem(1)};
`

function CarHireOrSimilarTooltip() {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'fZ3hTpsX7LoRBN02XDzk',
    defaultMessage: 'What does "or similar" mean?',
    description: 'Title for tooltip explaining car hire or similar vehicle labels',
  })

  const description = intl.formatMessage({
    id: 'SE-lgcwj1U4BKuN1rniO',
    defaultMessage: 'The exact model may vary, but you’ll always get a car in the same category, of the same size, with the same number of doors, gearbox and features. This is standard for most car rental companies.',
    description: 'Tooltip description explaining car hire or similar vehicle labels',
  })

  const ariaLabel = intl.formatMessage({
    id: 'F9-2N8vAnpWcLSUosuIp',
    defaultMessage: 'What does or similar mean?',
    description: 'Accessibility label for car hire or similar vehicle tooltip trigger',
  })

  return <RichTooltip
    title={title}
    description={description}
    variant="dark"
    placement="bottom"
    portaled
    dismissible={false}
    closeOnOutsideClick
    maxWidth={360}
    stopClickPropagation
  >
    <TooltipIcon role="button" tabIndex={0} aria-label={ariaLabel}>
      <LineInfoCircleIcon colour="normal-contrast" size="XS" />
    </TooltipIcon>
  </RichTooltip>
}

export default CarHireOrSimilarTooltip
